import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';
import {
  AppBar,
  Toolbar,
  Grid,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
import { assaAzul, assaAzulMovil } from '../../../svg';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    content: {
      padding: theme.spacing(1),
    },
    containerItem: {
      marginTop: 30,
      paddingBottom: 20,
    },
    appBar: {
      boxShadow: 'none',
    },
    leftItems: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
    },
    rightItems: {
      flex: 1,
      alignSelf: 'right',
      display: 'flex',
      flexDirection: 'row-reverse',
    },
    toolbarAppBar: {
      paddingLeft: 106,
      paddingRight: 57.83,
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 24,
        paddingRight: 16,
      },
    },
  }),
);

export type BasePageQuoteProps = {
  rightActions: React.ReactNode;
  leftActions?: React.ReactNode;
  appBarposition?: 'static' | 'fixed' | 'sticky';
  stepperItem?: React.ReactNode;
  children?: React.ReactNode;
  backgroundColor: string;
  addContentPadding?: boolean;
};

const BasePageQuotation = ({
  leftActions,
  rightActions,
  children,
  appBarposition = 'sticky',
  stepperItem,
  backgroundColor,
  addContentPadding = true,
}: BasePageQuoteProps): JSX.Element => {
  const classes = useStyles();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div className={classes.root}>
      <AppBar
        position={appBarposition}
        elevation={0}
        className={classes.appBar}
        style={{ background: backgroundColor }}
        data-testid="appbar"
      >
        <Toolbar className={classes.toolbarAppBar}>
          <Grid container className={classes.containerItem} spacing={1}>
            <Grid item xs={6} md={4}>
              <div className={classes.leftItems} data-testid="left-item">
                {/* Mobile Image Assa */}
                {isMobile && (
                  <img src={assaAzulMovil} alt="" width={80} height={19} />
                )}
                {/* Desktop Image Assa */}
                {!isMobile && (
                  <img src={assaAzul} alt="" height={56.02} width={147} />
                )}
                {/* Arrow Icon Left Desktop */}
                {!isMobile && leftActions !== null && leftActions}
              </div>
            </Grid>
            {/* Mobile */}
            {isMobile && (
              <Grid item xs={6} md={4} data-testid="right-item-mobile">
                <div className={classes.rightItems}>
                  {rightActions !== null && rightActions}
                </div>
              </Grid>
            )}
            <Grid item xs={12} md={4}>
              {stepperItem}
            </Grid>
            {/* Desktop */}
            {!isMobile && (
              <Grid item xs={6} md={4} data-testid="right-item-desktop">
                <div className={classes.rightItems}>
                  {rightActions !== null && rightActions}
                </div>
              </Grid>
            )}
          </Grid>
        </Toolbar>
      </AppBar>
      <div
        className={addContentPadding ? classes.content : ''}
        data-testid="content"
      >
        {children}
      </div>
    </div>
  );
};

export default BasePageQuotation;
